import script from "./pc-module-task-percent-5.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-task-percent-5.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-task-percent-5.vue?vue&type=style&index=0&id=25fbc671&lang=scss"

const __exports__ = script;

export default __exports__